export default __webpack_public_path__ + "static/cabin-deluxe-2-to-4-3-9245ed265bea9c95002ea4fc0a018ecf.jpg";